import { useLocation } from "react-router-dom";
import { AIRENE_URL } from "Config/constants";
import {Button,Icon,Text,Badge} from "./style";

function AireneButton(){
  const location = useLocation()
  const openAirene = ()  => {
    const topic = location.pathname.includes('attendance')
      ? 'attendance'
      : 'employee'
    window.open(`${AIRENE_URL}${topic}`, '_blank')
  }

  return <Button onClick={openAirene}>
    <Icon>
      <img
        src="https://cdn.mekari.design/template-assets/mekari-ask.gif"
        alt="smart assist icon"
        style={{width: '24px'}}
      />
    </Icon>
    <Text>Ask Airene</Text>
    <Badge>BETA</Badge>
  </Button>
}

export default AireneButton;